import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import React from "react";

import { useLocalStorage } from "../../hooks";

import { XMarkIcon } from "@heroicons/react/20/solid";
import { useDispatch, useSelector } from "react-redux";
import marker from "../../assets/location.svg";
import { TwButton, TwDropzone, TwFormHelperText, TwInputGroup, TwLabel, TwLocationInput, TwPhoneInputGroup, TwSelectGroup, TwSwitch } from "../../components/tailwind";
import { useToast } from "../../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading } from "../../redux/reducers/loadingReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForEvent } from "../../utils/confighelpers";
import email_img from "../../assets/Email.svg";
import institute_img from "../../assets/Institute.svg";
import { isValidEmail } from "../../helpers";
import { sellerTypes } from "../../utils/constants";
import { useTranslation } from "react-i18next";
import profile_img from "../../assets/avatar_placeholder.png";


export default function AddEditSellersModal({
  open,
  handleClose,
  handleUpdate,
  isEdit,
  selectedSellersData,
}) {
  const { t, i18n } = useTranslation();
  const { addErrorToast, addSuccessToast, addNotificationDialog } = useToast();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const [userToken] = useLocalStorage("userToken");
  const [locationName, setSellersName] = React.useState("");
  const [postalAddress, setPostalAddress] = React.useState({});
  const defaultData = {
    profilePic: "",
    name: "",
    mobile: "",
    email: "",
    channeltype: "",
    location: {},
    isAddPaymentAccount: false,
  }
  const [formValues, setFormValues] = React.useState({
    ...defaultData,
    ...selectedSellersData,
  });
  const [formErrors, setFormErrors] = React.useState({});

  const validateData = () => {
    const errors = {};
    if (!formValues.name) {
      errors.name = t("errors.required");
    }
    if (!formValues.channeltype) {
      errors.channeltype = t("errors.required");
    }
    if (formValues.email.length > 0 && isValidEmail(formValues.email) === false) {
      errors.email = t("errors.enterValidEmail");
    }

    if (formValues.isAddPaymentAccount != undefined && formValues.isAddPaymentAccount == true) {
      if (!formValues.mobile) {
        errors.mobile = t("errors.required");
      }
      if (!formValues.email) {
        errors.email = t("errors.required");
      } else if (formValues.email.length > 0 && isValidEmail(formValues.email) === false) {
        errors.email = t("errors.enterValidEmail");
      }
      if (!formValues.location) {
        errors.location = t("errors.required");
      }
      if (!Object.keys(postalAddress).length) {
        errors.postalAddress = t("errors.required");
      }
    }

    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
      return false;
    }
    return true;
  };

  const createSeller = async () => {

    if (validateData()) {
      let body = {
        profilePic: formValues.profilePic,
        name: formValues.name,
        mobile: formValues.mobile,
        email: formValues.email,
        channeltype: formValues.channeltype,
        location: formValues.location,
        isAddPaymentAccount: formValues.isAddPaymentAccount,
      }

      // return;

      const config = {
        method: "post",
        // url: isEdit === true ? `${getUrlForEvent()}seller/update/${formValues._id}` : `${getUrlForEvent()}seller/add`,
        url: `${getUrlForEvent()}seller/add`,
        data: body,
      };

      dispatch(setGlobalLoading(true));
      dispatch(setActionLoading(true));
      const addSellersRequest = await axiosInstance(config);
      dispatch(setGlobalLoading(false));
      dispatch(setActionLoading(false));
      if (addSellersRequest.data.statusCode === 200) {
        handleClose();
        setPostalAddress({});
        setFormValues({
          ...defaultData,
        })
        handleUpdate();
      } else if (addSellersRequest.data.statusCode !== 200) {
        if (addSellersRequest.data.statusCode === 500) {
          addErrorToast(addSellersRequest.data.message);
          return;
        } else if (addSellersRequest.data.message) {
          // addErrorToast(addSellersRequest.data.message);
          setFormErrors({ email: addSellersRequest.data.message });
          //   }
          // })
        }
        return;
      }
    } else {
      return;
    }
  };

  const updateSeller = async () => {

    if (validateData()) {
      let body = {
        profilePic: formValues.profilePic,
        name: formValues.name,
        mobile: formValues.mobile,
        email: formValues.email,
        channeltype: formValues.channeltype,
        location: formValues.location,
        ...(!selectedSellersData?.connectedStripeAccount?.profileDetails
          || !selectedSellersData?.connectedStripeAccount?.profileDetails.stripeAcId) ? { email: formValues.email, isAddPaymentAccount: formValues.isAddPaymentAccount } : {},
      }


      const config = {
        method: "post",
        url: `${getUrlForEvent()}seller/update/${formValues._id}`,
        data: body,
      };
      // return;

      dispatch(setGlobalLoading(true));
      dispatch(setActionLoading(true));
      const addSellersRequest = await axiosInstance(config);
      dispatch(setGlobalLoading(false));
      dispatch(setActionLoading(false));
      if (addSellersRequest.data.statusCode === 200) {
        handleClose();
        setPostalAddress({});
        setFormValues({
          ...defaultData,
        })
        handleUpdate();
      } else if (addSellersRequest.data.statusCode !== 200) {
        if (addSellersRequest.data.statusCode === 500) {
          addErrorToast(addSellersRequest.data.message);
          return;
        }
        return;
      }
    } else {
      return;
    }
  };


  React.useEffect(() => {
    if (isEdit && isEdit === true) {
      let location = selectedSellersData.location
      if (location?.address) {
        setPostalAddress({
          placeDetails: {
            description: location.address,
            structured_formatting: { main_text: location.houseNumber },
          },
          placeGeocode: {
            address_components: [
              {
                long_name: location.address,
                short_name: location.address,
                types: ["locality", "political"],
              },
              {
                long_name: location.address,
                short_name: location.address,
                types: ["locality", "political"],
              },
              {
                long_name: location.address,
                short_name: location.address,
                types: ["locality", "political"],
              },
              {
                ...(location?.zip && location.zip !== "") ? {
                  long_name: location.zip,
                  short_name: location.zip,
                  types: ["postal_code"],
                } : {
                  long_name: location.address,
                  short_name: location.address,
                  types: ["locality", "political"],
                }
              },
            ]
          },
          coordinates: location.location.coordinates
        });
      }
      if (selectedSellersData?.connectedStripeAccount?.profileDetails
        && selectedSellersData?.connectedStripeAccount?.profileDetails.stripeAcId
        && selectedSellersData?.connectedStripeAccount?.profileDetails.stripeAcId !== "") {

      }

    } else {
      setPostalAddress({});
      setFormValues({
        ...defaultData,
      })
      setFormErrors({})
    }
    setFormValues({
      ...defaultData,
      ...selectedSellersData,
    })
  }, [isEdit, selectedSellersData]);


  return (
    <Dialog
      open={open}
      onClose={() => {
        // })
        // handleClose();
      }}
      className="relative z-50"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-md sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
              <button
                type="button"
                onClick={handleClose}
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span className="sr-only">{t("inputFieldsTitle.close")}</span>
                <XMarkIcon aria-hidden="true" className="size-6" />
              </button>
            </div>
            <div className="flex flex-col gap-4">
              <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                {isEdit ? t("inputFieldsTitle.updateSeller") : t("inputFieldsTitle.addSeller")}
              </DialogTitle>

              <TwDropzone
                // label={"Your Logo"}
                variant={"profile"}
                name={"profilePic"}
                uploadBtnText={formValues.profilePic !== "" ? t("inputFieldsTitle.changePic") : t("inputFieldsTitle.uploadImage")}
                defaultValue={profile_img}
                value={formValues?.profilePic}
                errors={formErrors}
                onChange={(image) => {
                  if (image) {
                    setFormValues((prevValues) => ({
                      ...prevValues,
                      profilePic: image,
                    }));
                  }
                }}
                isShowDeletBtn={true}
                onDelete={() => {
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    profilePic: "",
                  }));
                  // }
                }}
              />
              <TwInputGroup
                label={t("mySellers.sellersName")}
                name={"name"}
                placeholder={t("mySellers.sellersName")}
                // leftIcon={(<img className={""} src={institute_img} alt={""} />)}
                value={formValues.name}
                onChange={(e) => {
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    name: e.target.value,
                  }));
                }}
                errors={formErrors}
              />

              <TwSelectGroup
                label={t("mySellers.sellerType")}
                placeholder={t("mySellers.sellerType")}
                name={"channeltype"}
                // leftIcon={<img className="size-5" src={ticketStarIcon} />}
                options={[{ value: "", title: t("mySellers.selectSellerType") }, ...sellerTypes]}
                defaultValue={formValues.channeltype}
                value={formValues.channeltype}
                onChange={(event) => {

                  setFormValues((prevValues) => ({
                    ...prevValues,
                    channeltype: event.target.value,
                  }));
                }}
                errors={formErrors} />

              <TwPhoneInputGroup
                label={t("inputFieldsTitle.mobileNumber")}
                placeholder={t("inputFieldsTitle.mobileNumber")}
                name={"mobile"}
                value={formValues.mobile}
                country={"nl"}
                onChange={(phone, country, e) => {
                  const numberWithoutDialCode = phone.split("");
                  for (let i = 0; i < country.dialCode.length; i++) {
                    numberWithoutDialCode.shift();
                  }
                  let dialCode = country.dialCode;
                  if (
                    country.format.includes("+") &&
                    !country.dialCode.includes("+")
                  ) {
                    dialCode = "+".concat(country.dialCode);
                  }
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    formattedPhoneNumber: e.target.value,
                    mobile: e.target.value,
                    // mobile: numberWithoutDialCode.join(""),
                  }));
                }}
                errors={formErrors}
              />
              <TwInputGroup
                label={t("inputFieldsTitle.email")}
                placeholder={t("inputFieldsTitle.emailAddress")}
                name={"email"}
                value={formValues?.email}
                onChange={(e) => {
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    email: e.target.value,
                  }));
                }}
                errors={formErrors}
              />
              <TwLocationInput
                label={t("inputFieldsTitle.businessAddress")}
                name={"postalAddress"}
                leftIcon={(<img className={""} src={marker} alt={""} />)}
                defaultLocationSelect={postalAddress?.placeDetails}
                onLocationSelect={(data, postAdd) => {

                  // setPostalAddress({ placeDetails: e, placeGeocode: placeDetails, coordinates: coordinates });
                  setPostalAddress(postAdd);
                  setFormValues((prevValues) => ({
                    ...prevValues,
                    location: data,
                  }));

                  // setAddress(data);
                }}
                errors={formErrors}
              />
              {(!selectedSellersData?.connectedStripeAccount?.profileDetails
                || !selectedSellersData?.connectedStripeAccount?.profileDetails.stripeAcId) ? (
                <div className="flex flex-col gap-1">
                  <TwSwitch
                    title={t("mySellers.addPaymentAccount")}
                    name={"isAddPaymentAccount"}
                    checked={formValues?.isAddPaymentAccount}
                    onChange={() => {
                      setFormValues((prevValues) => ({
                        ...prevValues,
                        isAddPaymentAccount: !formValues.isAddPaymentAccount,
                      }));
                    }}
                  />
                  {formValues?.isAddPaymentAccount == true && (<TwFormHelperText className="pl-14">{t("mySellers.addPaymentAccountHelperTest")}</TwFormHelperText>)}
                </div>
              ) : (
                <div className="flex flex-col gap-2 border-t border-gray-900/10 pt-5">
                  <TwLabel className="!font-bold text-secondary">{t("mySellers.paymentAccountDetails")}</TwLabel>
                  <TwLabel className="">
                    {t("mySellers.paymentAccountId")}
                    <br />
                    <span className="text-black">{selectedSellersData?.connectedStripeAccount?.profileDetails?.stripeAcId}</span>
                  </TwLabel>

                  <TwLabel>{t("mySellers.status")} <br />{selectedSellersData?.connectedStripeAccount?.profileDetails
                    && selectedSellersData?.connectedStripeAccount?.profileDetails.stripeAcId
                    && selectedSellersData?.connectedStripeAccount?.profileDetails.stripeAcId !== ""
                    && selectedSellersData?.connectedStripeAccount?.profileDetails.stripeOnBoardindStatus
                    && selectedSellersData?.connectedStripeAccount?.profileDetails.stripeOnBoardindStatus === "SUCCESS" ? <span className="text-green-400">Active</span> : <span className="text-orange-400">{t("mySellers.pending")}</span>}</TwLabel>

                  {selectedSellersData?.connectedStripeAccount?.profileDetails
                    && selectedSellersData?.connectedStripeAccount?.profileDetails.stripeAcId
                    && selectedSellersData?.connectedStripeAccount?.profileDetails.stripeAcId !== ""
                    && selectedSellersData?.connectedStripeAccount?.profileDetails.stripeOnBoardindStatus
                    && selectedSellersData?.connectedStripeAccount?.profileDetails.stripeOnBoardindStatus !== "SUCCESS" && (

                      <div className="inline-flex flex-col gap-y-2 items-start">
                        <TwLabel className="">
                          {t("mySellers.bankSccountDetailsMessage")}
                        </TwLabel>
                        <TwButton
                          variant={"default-small"}
                          className="sm:w-auto"
                          disabled={loadingReduxState.actionLoading}
                          actionLoading={(loadingReduxState.actionLoading)}
                          onClick={async () => {
                            const config = {
                              method: "post",
                              url: `${getUrlForEvent()}payments/getConnectedACLink`,
                              data: {
                                "organizerId": selectedSellersData?.organizerId,
                                "accountType": "sellers",
                                "userReferenceId": selectedSellersData?._id
                              },
                            };
                            // return;

                            dispatch(setGlobalLoading(true));
                            dispatch(setActionLoading(true));
                            const getConnectedACLinkRequest = await axiosInstance(config);
                            dispatch(setGlobalLoading(false));
                            dispatch(setActionLoading(false));
                            if (getConnectedACLinkRequest.data.statusCode === 200) {
                              if (getConnectedACLinkRequest.data?.data
                                && getConnectedACLinkRequest.data?.data?.on_boarding_url
                                && getConnectedACLinkRequest.data?.data?.on_boarding_url !== ""
                              ) {
                                navigator.clipboard.writeText(getConnectedACLinkRequest.data?.data?.on_boarding_url);
                                addSuccessToast(t("myEvents.copied"));
                              } else {
                                getConnectedACLinkRequest.data?.message && addSuccessToast(getConnectedACLinkRequest.data?.message || "");
                              }
                            } else if (getConnectedACLinkRequest.data.statusCode !== 200) {
                              if (getConnectedACLinkRequest.data.statusCode === 500) {
                                addErrorToast(getConnectedACLinkRequest.data.message);
                                return;
                              }
                              return;
                            }
                          }}
                        >
                          {t("mySellers.resendOnboardingLink")}
                        </TwButton>

                      </div>
                    )}
                </div>
              )}
            </div>
            <div className="mt-5 sm:mt-4 flex flex-col gap-3 sm:flex-row-reverse ">
              <TwButton
                variant={"secondary"}
                className="w-full sm:w-auto"
                disabled={loadingReduxState.actionLoading}
                actionLoading={(loadingReduxState.actionLoading)}
                onClick={async () => {
                  if (validateData()) {
                    if (isEdit === true) {
                      await updateSeller();
                    } else {
                      await createSeller();
                    }
                  }
                  // postAddress();
                }}
              >
                {isEdit ? t("inputFieldsTitle.updateSeller") : t("inputFieldsTitle.addSeller")}
              </TwButton>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}
